import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CrudOrgPermissionsFacade } from './crud-org-permissions.facade';
import { FormGroup } from '@angular/forms';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';

export type CrudOrgPermissionsMode = 'read' | 'update';

@Component({
    selector: 'app-crud-org-permissions',
    imports: [...COMMON_IMPORTS, MultiSelectModule, ButtonModule, DialogModule, TranslateModule],
    templateUrl: './crud-org-permissions.component.html'
})
export class CrudOrgPermissionsComponent implements OnInit, OnChanges {
  @Input() orgId!: string;
  @Input() mode: CrudOrgPermissionsMode = 'read';
  uiState$ = this.facade.uiState$;

  showConfirmDialog = false;
  pendingUserId: string | null = null;
  pendingForm: FormGroup | null = null;

  // Add properties for delete confirmation
  showDeleteConfirmDialog = false;
  pendingDeleteUserId: string | null = null;
  pendingDeleteUserName: string | null = null;

  constructor(public facade: CrudOrgPermissionsFacade) {}

  ngOnInit() {
    if (this.orgId) {
      this.facade.load(this.orgId, this.mode);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['mode'] && !changes['mode'].firstChange && this.orgId) {
      this.facade.load(this.orgId, this.mode);
    }
  }

  onSave(userId: string, form: FormGroup) {
    if (this.mode === 'update') {
      const selected = form.value.permissions;
      if (!selected || selected.length === 0) {
        this.pendingUserId = userId;
        this.pendingForm = form;
        this.showConfirmDialog = true;
        return;
      }
      this.facade.updateUserPermissions(userId, form);
    }
  }

  onConfirmRemoveAll() {
    if (this.pendingUserId && this.pendingForm) {
      this.facade.updateUserPermissions(this.pendingUserId, this.pendingForm);
    }
    this.showConfirmDialog = false;
    this.pendingUserId = null;
    this.pendingForm = null;
  }

  onCancelRemoveAll() {
    this.showConfirmDialog = false;
    this.pendingUserId = null;
    this.pendingForm = null;
  }

  // Add methods for handling deletion
  onDeleteUser(userId: string, userName: string) {
    if (this.mode === 'update') {
      this.pendingDeleteUserId = userId;
      this.pendingDeleteUserName = userName;
      this.showDeleteConfirmDialog = true;
    }
  }

  onConfirmDelete() {
    if (this.pendingDeleteUserId) {
      this.facade.deleteUser(this.pendingDeleteUserId);
    }
    this.closeDeleteDialog();
  }

  onCancelDelete() {
    this.closeDeleteDialog();
  }

  private closeDeleteDialog() {
    this.showDeleteConfirmDialog = false;
    this.pendingDeleteUserId = null;
    this.pendingDeleteUserName = null;
  }
}
